import { render, staticRenderFns } from "./AccommodationPriceUpdation.vue?vue&type=template&id=2e948418&scoped=true&"
import script from "./AccommodationPriceUpdation.vue?vue&type=script&lang=js&"
export * from "./AccommodationPriceUpdation.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationPriceUpdation.vue?vue&type=style&index=0&id=2e948418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e948418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VTextField})
